import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { User } from '../user/user';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';
import { tap } from 'rxjs/operators/';
import { Authenticate } from '../authenticate/authenticate';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserService {
  auth: Authenticate;
  constructor(private http: HttpClient) { }

  // GET ALL USERS
  getAll() { return this.http.get<User[]>(`${environment.appURL}/users`, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }); }

  // GET USER BY ID
  getById(id: number) { return this.http.get(`${environment.appURL}/users/` + id, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }); }

  // REGISTER USER 
  register(user: User) { return this.http.post(`${environment.appURL}/users/register`, user, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }); }

  // UPDATE USER DETAILS
  update(user: User) {
    var upd = this.userStr(user);
    var command = `${environment.appURL}/users/` + user.id;
    return this.http.put(command, upd, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) });
  }

  // DELETE USER BY ID 
  delete(id: number) { return this.http.delete(`${environment.appURL}/users/` + id, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }); }

  // GET USER BY ID
  getUserById(id: number) {
    const url = `${environment.appURL}/users/${id}`;
    return this.http.get<User>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) })
      .pipe(
        tap(_ => { }),
        catchError(this.handleError<User>(`getModule id=${id}`))
      );
  }

  // GET USER FROM COOKIE 
  getCurrentUserFromCookie() {
    try {
      this.auth = JSON.parse(sessionStorage.getItem('currentUser'));
      if (this.auth == null) {
        return null;
      }
      else return this.auth.user;
    }
    catch {
      return null;
    }
  }

  // GET CURRENT USER FROM SESSION STORAGE
  getCurrentUser() {
    try {
      this.auth = JSON.parse(sessionStorage.getItem('currentUser'));
      if (this.auth != null) {
        return this.getUserById(this.auth.user.id);
      }
      else
        return null;
    }
    catch (e) {
      console.log("we caught an error!!" + e);
      return null;
    }
  }

  // CREATE USER JSON STRING
  userStr(user: User): string {
    if (user.password === undefined) {
      return "{\"firstname\":\"" + user.firstname + "\",\"lastname\":\"" + user.lastname + "\" ,\"img\":\"" + user.img + "\"}";
    }
    else {
      return "{\"firstname\":\"" + user.firstname + "\",\"lastname\":\"" + user.lastname + "\",\"password\":\"" + user.password + "\" ,\"img\":\"" + user.img + "\"}";
    }
  }

  // GET USER ROLE FROM SESSION STORAGE    
  getUserRole() {
    this.auth = JSON.parse(sessionStorage.getItem('currentUser'));
    let jwt = this.auth.jwt;
    let role = this.auth.user.role.name;
    return role;
  }

  // GET LIST OF CLIENT USERS BY CLIENT ID
  getCSUsers(client: number) {
    const url = environment.graphURL + "{users (where:{client:" + client + "}){id firstname lastname }}";
    return this.http.get(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) }).pipe(map(data => data['data']['users'])
    );
  }

  // ERROR HANDLER
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}

